import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Form from "./components/Form";

function App() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: 24,
        height: "100vh",
      }}
    >
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        style={{ width: "100%" }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            paddingTop: 64,
          }}
        >
          <div
            style={{
              height: 64,
              borderBottomColor: "#ccc",
              borderBottomWidth: 1,
              borderBottomStyle: "solid",
              display: "flex",
              flexDirection: "row",
              paddingLeft: 16,
              paddingRight: 16,
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              gap: 8,
              alignItems: "center",
            }}
          >
            <h2 style={{ flex: 1 }}>{"Boundless Application"}</h2>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              overflow: "auto",
              paddingBottom: 24,
            }}
          >
            <Form />
          </div>
        </div>
      </LocalizationProvider>
    </div>
  );
}

export default App;
